<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <h1 class="content-header-title">{{ $t('pages.usermanual.list.title') }}</h1>
            </section>
        </header>
        <div class="content-data no-top">
            <div class="content-item">
                <div class="content-item-value">
                    {{ $t('pages.usermanual.list.manul_title') }}
                </div>
                <div class="content-item-button">
                    <a :href="`${ publicPath }Handbuch für das Travel Admin Content Management System (CMS).pdf`" class="button button-gray">{{ $t('pages.usermanual.list.read_pdf') }}</a>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'UserManual',
    data() {
        return {
            publicPath: process.env.BASE_URL,
        };
    },

};
</script>
